<template>
  <div class="item">
    <v-card
      class="rounded-3"
      ripple
      hover
      :to="{ name: 'credit-pay/requests/detail', params: { uuid: this.item.uuid } }"
    >
      <v-card-text class="pr-2">
        <v-layout justify-space-between align-center>
          <div>
            <span><RequestStatus :status="item.status" /></span>&nbsp;
            <span>{{ item.created | moment('YYYY-MM-DD HH:mm:ss') }}</span>
          </div>
          <v-icon>mdi-chevron-right</v-icon>
        </v-layout>

        <v-layout class="mb-3">
          <template v-if="wholesaler">
            <span class="color--nice-black font--m-3">
              {{ wholesaler.name }}
            </span>
            <span class="px-2 grey--text font--m-6">|</span>
          </template>
          <span class="color--nice-black font--m-3">{{ item.amount | commaFormat }}원</span>
        </v-layout>

        <v-layout class="color--nice-black font-weight-bold">
          <span class="pr-2">입금자명</span>
          <span>
            {{ item.depositName }}
          </span>
        </v-layout>

        <v-layout class="color--nice-black font-weight-bold">
          <span>
            {{ item.bank | bankShortName }} {{ item.accountNumber }} {{ item.holderName }}
          </span>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ['item'],
  data() {
    return {}
  },
  components: {
    RequestStatus: () => import('./RequestStatus.vue'),
  },
  async created() {},
  computed: {
    ...mapState('creditPay/wholesaler', ['wholesalerAccounts']),

    wholesaler() {
      return this.item.wholesaler
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.item:not(:last-of-type) {
  margin-bottom: 16px;
}
</style>
